import { connect } from 'react-redux'
import BullshitSpan from './BullshitSpan'

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
}

const BullshitSpanContainer = connect(
    mapStateToProps,
)(BullshitSpan)

export default BullshitSpanContainer
